import { createFetcherWithTTL } from "../../core/cache";
import { ExpressionResolverFn, ExternalResources } from "../../core/types";

export function createCachedResolver(
  resolver: ExpressionResolverFn,
  ttl: number
): ExpressionResolverFn {
  const cache = createFetcherWithTTL(ttl);

  return async (config) => {
    const cacheKey = generateCacheKey(config);
    return cache(cacheKey, () => resolver(config));
  };
}

function generateCacheKey(config: {
  expression: { function?: string; params?: Record<string, any> };
  externalResources?: ExternalResources;
}): string {
  const { expression, externalResources } = config;

  // Create cache key based on expression signature and relevant context
  const keyParts = {
    function: expression.function,
    params: expression.params,
    // Include auth context for permission-based expressions
    advisorId: externalResources?.authConfig?.advisorId,
  };

  // Generate deterministic cache key
  return JSON.stringify(keyParts);
}
